var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('i',{staticClass:"iconfont",class:_vm.name,style:(_vm.styleFont),on:{"click":_vm._click}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }